import { getLength } from 'ol/sphere'

const Utils = {
  /**
   * Create new icon for the rotate button to be re-assigned
   *
   * @src https://florianbrinkmann.com/en/svg-use-element-javascript-4513/
   * @returns svgElem
   */
  compassIcon () {
    const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    const useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use')

    svgElem.setAttribute('role', 'button')
    svgElem.setAttribute('aria-label', 'compass')
    svgElem.classList.add('ol-compass', 'compass-svg', 'block', 'w-5', 'h-5', 'cursor-pointer', 'select-none', 'z-120')

    useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#compass')
    svgElem.appendChild(useElem)

    return svgElem
  },

  /**
   * Format length output. Used with LineStrings only.
   *
   * @param {LineString} line The line.
   * @return {string} The formatted length.
   */
  formatLength (line) {
    // Returns the spherical length (in meters).
    const length = getLength(line)
    const output = {}

    output.km = (((length / 1000) * 100) / 100).toFixed(3)
    output.m = ((length * 100) / 100).toFixed(3)

    output.miles = (output.km * 0.621371).toFixed(3)
    output.seamiles = (output.km * 0.539957).toFixed(3)
    output.yards = (output.m * 1.09361).toFixed(3)
    output.feet = (output.m * 3.28084).toFixed(3)
    output.inches = (output.m * 39.3701).toFixed(3)

    return output
  }
}

export default Utils
